import { IconWrapper } from '../runtime';
export default IconWrapper('cloud-documents', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M13.25 7.49966V5.12098C13.25 4.72316 13.092 4.34163 12.8107 4.06032L10.9393 2.189C10.658 1.9077 10.2765 1.74966 9.87868 1.74966H4.25C3.42157 1.74966 2.75 2.42124 2.75 3.24966V12.7497C2.75 13.5781 3.42157 14.2497 4.25 14.2497H6M12.9995 11.293C12.9998 11.2786 13 11.2642 13 11.2497C13 10.1451 12.1046 9.24966 11 9.24966C9.95606 9.24966 9.09893 10.0495 9.00798 11.0698C8.28101 11.2824 7.75 11.954 7.75 12.7497C7.75 13.7162 8.5335 14.4997 9.5 14.4997H12.625L12.63 14.4997C13.5252 14.497 14.25 13.7705 14.25 12.8747C14.25 12.1061 13.7164 11.4622 12.9995 11.293Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});